import { Injectable } from "@angular/core";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class CommonDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  deleteAll() {
    return this.ipcSendSync(IPC_CHANNEL.DB.DELETE_ALL);
  }
}
